import React, { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom'
import { AccountContext } from '../Accounts'
import { AgenticContainer, History, FormH1, Message, InputWrapper, InputCard, ExpandingTextarea, SendButton, SpinningIcon, CardContainer, LinkButton, ClearButton, ScrollArea } from "./AgenticElements";
import SendPrompt from '../BedrockLibrary/PromptGeneration';
import SlateCard from './SlateCard';
import PlayerCard from './PlayerDisplay';
import GetPublicResource from './GetResource';
// import SendPrompt from '../BedrockLibrary/PromptGeneration';
const AgenticCashCrew = () => {
    const [status, setStatus] = useState(false);
    const [messages, setMessages] = useState(() => {
        const saved = localStorage.getItem("chatMessages");
        return saved ? JSON.parse(saved) : [];
    });

    const [input, setInput] = useState("");
    const [loadingBoolean, setLoadingBoolean] = useState(false);
    const [timeframe, setTimeFrame] = useState();
    const [slates, setSlates] = useState([]);
    const [slateIDs, setSlateIDs] = useState([]);
    const [slateList, setSlateList] = useState([]);

    const [slate, setSlate] = useState();
    const [players, setPlayers] = useState([]);
    const [assets, setAssets] = useState([]);

    const { getSession, email } = useContext(AccountContext);

    const navigate = useNavigate();
    const sessionId = crypto.randomUUID();

    const bottomRef = useRef(null);

    useEffect(() => {
        bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages, loadingBoolean]); // Trigger scroll when messages or loading state changes


    useEffect(() => {
        getSession()
            .then(session => {
                setStatus(true);
            })
            .catch(err => {
                console.log(err);
                navigate('/signin')
            })
    });
    // Save messages
    useEffect(() => {
        localStorage.setItem("chatMessages", JSON.stringify(messages));
    }, [messages]);

    // useEffect(() => {
    //     if (slate) {
    //         const teamsWait = async () => {
    //             const slateTeams = timeframe.ApiSeason + "/" + timeframe.ApiWeek + "/" + slate.SlateID + "_teams.json"
    //             // console.log(slate)
    //             // console.log(slateTeams)
    //             const teamsInWait = await GetPublicResource(slateTeams).then(teams => teams)
    //             setTeams(teamsInWait);
    //             setListStatus(true);
    //         }
    //         teamsWait()
    //             .catch(console.error());;
    //     }
    // }, [slate]);
    useEffect(() => {
        if (timeframe) {
            const slatesWait = async () => {
                try {
                    const slatesPath = `${timeframe.ApiSeason}/${timeframe.ApiWeek}/slates.json`;
                    const slatesInWait = await GetPublicResource(slatesPath);
                    setSlates(slatesInWait);
                    // console.log(slates)
                } catch (error) {
                    console.error(error);
                }
            };

            slatesWait();
        }
    }, [timeframe]);


    useEffect(() => {
        if (slateIDs) {
            setSlateList(slates.filter(x => slateIDs.includes(x.SlateID.toString())))
            // console.log(slateList)
        }
    }, [slateIDs]);

    useEffect(() => {
        if (slates.length === 1 && timeframe) {
            const projectionPlayersInWait = async () => {
                try {
                    const assetPath = `${timeframe.ApiSeason}/${timeframe.ApiWeek}/${slates[0].SlateID.toString()}_assets.json`;
                    const playersInWait = await GetPublicResource(assetPath);
                    // console.log(playersInWait.assets)
                    setAssets(playersInWait.assets.filter(x => players.includes(x.name)));
                    // console.log(assets)
                } catch (error) {
                    console.error(error);
                }
            };

            projectionPlayersInWait();
        }
    }, [slates, timeframe, players]);

    const handleSend = async () => {
        if (!input.trim()) return;
        setSlateList([]);
        setAssets([]);
        const userMessage = { role: "user", content: input };
        setMessages((prev) => [...prev, userMessage]);
        setInput("");

        // Stubbed API call — replace with your actual Bedrock/OpenAI endpoint
        const response = await agentCall(input);
        // Fix line breaks inside "response" field
        const restructured = restructurePayload(response)
        // console.log(restructured)
        if (restructured.apiSeason != "" && restructured.apiWeek != "") {
            setTimeFrame({ ApiSeason: restructured.apiSeason, ApiWeek: restructured.apiWeek })
        }
        setSlateIDs(restructured.slateIDs)
        setPlayers(restructured.players)
        const assistantMessage = { role: "assistant", content: JSON.stringify(restructured) };
        setMessages((prev) => [...prev, assistantMessage]);
    };

    const restructurePayload = (payload) => {
        // Try parsing the string
        try {
            return JSON.parse(payload);
        } catch (err) {
            // If it fails, sanitize the response field and try again
            // console.log(err)
            try {
                const rawOutput = payload;
                const jsonStart = rawOutput.indexOf('{');
                const jsonEnd = rawOutput.lastIndexOf('}');
                const jsonOnly = rawOutput.slice(jsonStart, jsonEnd + 1);
                const safe = jsonOnly.replace(
                    /"response":\s*"((?:[^"\\]|\\.)*)"/,
                    (match, p1) => {
                        const escaped = p1.replace(/\n/g, "\\n").replace(/"/g, '\\"');
                        return `"response": "${escaped}"`;
                    }
                );
                // console.log(safe);
                return JSON.parse(safe);
            } catch (err2) {
                // Final fallback

                // console.log(err2)
                return {
                    response: payload,
                    ApiSeason: "",
                    ApiWeek: "",
                    slateIDs: [],
                    players: []
                };
            }


        };
    }

    const agentCall = async (prompt) => {
        setLoadingBoolean(true);
        try {
            const res = await SendPrompt(sessionId, prompt);
            // console.log(res);
            setLoadingBoolean(false);
            return res;
        } catch (error) {
            console.error('Error calling Bedrock:', error);
            setLoadingBoolean(false);
            throw error;
        }
    };

    return (
        <div>
            {status ? (
                <AgenticContainer className="agentic-container">
                    <FormH1 className="chat-header">Ca$h Crew Mind</FormH1>
                    <History>
                        {messages.map((msg, idx) => (
                            <Message key={idx} style={{ whiteSpace: 'pre-line' }} role={msg.role}>
                                {msg.role === 'user' ? msg.content : JSON.parse(msg.content).response}
                            </Message>
                        ))}
                        {loadingBoolean && < SpinningIcon />}
                        <div ref={bottomRef} />
                    </History>
                    {slateList.length > 0 && (
                        <>
                            <CardContainer>
                                {
                                    slateList.map(p => (
                                        <SlateCard key={p.SlateID} slate={p} />
                                    ))}
                            </CardContainer>
                        </>
                    )
                    }
                    {assets.length > 0 && (
                        <>
                            <CardContainer>
                                {
                                    assets.map(p => (
                                        <PlayerCard player={p} />
                                    ))}
                            </CardContainer>
                        </>
                    )
                    }
                    {assets.length > 0 || slateList.length > 0 && <LinkButton style={{ marginBottom: '20px' }} to={'/crewbuilder'}>View In Crew Builder</LinkButton>}
                    <InputWrapper>
                        <InputCard>
                            {messages.length > 0 && (
                                <ClearButton onClick={() => setMessages([])} disabled={loadingBoolean}>
                                    Clear Chat
                                </ClearButton>
                            )}

                            <ExpandingTextarea
                                type="text"
                                placeholder="🧠 How Can I Help You Get That W?"
                                value={input}
                                onChange={(e) => setInput(e.target.value)}
                                onKeyDown={(e) => e.key === "Enter" && handleSend()}
                                disabled={loadingBoolean}
                            />

                            <SendButton onClick={handleSend} disabled={loadingBoolean}>
                                {loadingBoolean ? <SpinningIcon /> : 'Send'}
                            </SendButton>
                        </InputCard>
                    </InputWrapper>
                </AgenticContainer>) :
                <></>
            }
        </div>
    );
}

export default AgenticCashCrew;